import { makeAutoObservable } from 'mobx';

// eslint-disable-next-line import/no-unresolved
import { WIDTH_THRESHOLD } from '../utils/constants';
// eslint-disable-next-line import/no-cycle

class Store {
  scrollYOffset = 0

  location = {}

  pathnameHistory = []

  tags = {}

  showTags = []

  rings = []

  first20Rings = []

  first20Diamonds = []

  filterRings = []

  productImages = []

  isShowOverlay = false;

  videoDialog = null

  theme = 'black';

  get themeTextColor() {
    return this.theme == 'black' ? '#000' : '#927470';
  }

  get themeHeaderTextColor() {
    return this.theme == 'black' ? '#000' : '#d78b8f';
  }

  get themeBGColor() {
    return this.theme == 'black' ? '#FFF' : '#f8e8e9';
  }

  get themeFooterBGColor() {
    return this.theme == 'black' ? '#000' : '#f8e8e9';
  }

  setShowOverlay(b) {
    this.isShowOverlay = b;
  }

  screenSize = {
    width: document.documentElement.clientWidth,
    height: document.documentElement.clientHeight,
  }

  setScreenSize(s) {
    this.screenSize = s;
  }

  setScrollYOffset(s) {
    this.scrollYOffset = s;
  }

  get isDesktop() {
    return this.screenSize.width > WIDTH_THRESHOLD;
  }

  customizeHappinessDialog = false

  constructor() {
    makeAutoObservable(this);
  }
}

export const store = new Store();
